import request from "@/utils/request.js"

// 查询组织合作关系
export const getStoreCooperation = (storeId) => {
    return request.get(`/storeCooperation/${storeId}`)
}
// 添加或修改组织合作关系
export const uploadStoreCooperation = (formData) => {
    return request.post(`/storeCooperation`, formData)
}
